import React, { Component } from 'react';
import {Link} from 'react-router-dom';

export class CorporateLocations extends Component {
    state = {  }
    render() { 
        return ( 
            <div class="col" style={{backgroundColor: 'lightgrey'}}>
              <h5 class="heading mt-3 ml-2" style={{fontWeight: 'bold', fontSize: 15, color: '#5F6062'}}>CORPORATE LOCATIONS</h5>
              <div class="row ml-2">
                <h3 class="heading mt-1" style={{fontWeight: 'bold', fontSize: 20, color: '#EE3124'}}>HOUSTON TEXAS</h3>
                &nbsp;
                <h3 class="mt-1" style={{fontWeight: 'bold', color: '#00ACD4', fontSize: 20}}>-</h3>
                &nbsp;
                <h3 class="heading mt-1" style={{fontWeight: 'bold', fontSize: 20, color: '#EE3124'}}>USA</h3>
              </div>
              <div class="ml-2">
                <span class="txt subheading" style={{fontSize: 13}}>9990 Richmond Ave, STE 200N<br/></span>
                <span class="txt subheading" style={{fontSize: 13}}>Houston, TX 77042 USA </span>
                <a href='https://goo.gl/maps/C36CLqhesqhZ64t3A' class="link" style={{fontSize: 13}}> 
                  (Map)
                </a><br/>
                <span class="txt subheading" style={{fontSize: 13}}>Tel: 281.888.6789</span>
              </div>
              <div class="row ml-2">
                <h3 class="heading mt-1" style={{fontWeight: 'bold', fontSize: 20, color: '#EE3124'}}>KUALA LUMPUR</h3>
                &nbsp;
                <h3 class="mt-1" style={{fontWeight: 'bold', color: '#00ACD4', fontSize: 20}}>-</h3>
                &nbsp;
                <h3 class="heading mt-1" style={{fontWeight: 'bold', fontSize: 20, color: '#EE3124'}}>MALAYSIA</h3>
              </div>
              <div class="ml-2">
                <span class="txt subheading" style={{fontSize: 13}}>19-9-6, UOA Centre, KLCC<br/></span>
                <span class="txt subheading" style={{fontSize: 13}}>19, Jalan Pinang, 50450 Kuala Lumpur, Malaysia </span>
                <a href='https://maps.app.goo.gl/bHPxzUZqKZYPe5Cy5' class="link" style={{fontSize: 13}}> 
                  (Map)
                </a><br/>
                <span class="txt subheading" style={{fontSize: 13}}>Tel: +60 12 462 8982</span>
              </div>
            </div>
           
         );
    }
}
 
